import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { FaEnvelope, FaSms, FaWhatsapp } from 'react-icons/fa';

const Icons = {
  whatsapp: FaWhatsapp,
  sms: FaSms,
  email: FaEnvelope,
};
export const CampaignHeader = () => {
  const { t } = useTranslation('campaign');
  const params = useParams<{ tab?: string }>();
  const tabId = params.tab || 'whatsapp';

  const selectedCampaign = tabId === 'sms' ? 'SMS' : tabId === 'email' ? 'Email' : 'WhatsApp';
  const IconComponent = Icons[tabId as keyof typeof Icons] || FaWhatsapp;

  return (
    <div className='flex items-center justify-between'>
      <div className='flex items-center gap-3'>
        <div className='flex rounded-full bg-primary-icon p-2'>
          <IconComponent className='size-6 text-primary-600' />
        </div>
        <h1 className='text-2xl font-semibold text-gray-900'>
          {t(`campaignPageTitle`, {
            campaignName: selectedCampaign,
          })}
        </h1>
      </div>
    </div>
  );
};
